import axios from "axios";
import { toast } from "react-toastify";
export const GetAllNotification = (data) => {
  return {
    type: "get_allNotification",
    payload: data,
    loader: false,
  };
};
export function getallNotifications() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Vouchers/GetAllNotifications`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllNotification(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
